import reducer from './reducers';
import * as seventhAnalysesActions from './actions';
import * as seventhAnalysesSelectors from './selectors';

export { seventhAnalysesActions, seventhAnalysesSelectors };
export default reducer;